import { PATHS } from "../utills/paths";
import { App, Menu, Avatar } from "antd";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAuthContext } from "../components/user/AuthProvider";
import CustomIcon from "../components/layouts/CustomIcon";

export default function SettingsSidebarMenu() {
  const navigate = useNavigate();
  const { modal } = App.useApp();
  const { userAccess } = useAuthContext();
  const { pathname = "" } = useLocation();

  const { isEditor = false, isCollaborator = false, isWorkspaceAdmin = false, isAdmin = false, isOwner = false } = userAccess || {};
  const hide = isEditor || isCollaborator; // Hide the some menu items for editor and collaborator

  const items = [
    { key: PATHS.V2.ORGANIZATION, label: "Organization", className: hide || isWorkspaceAdmin ? "d-none" : "" },
    { key: PATHS.V2.PEOPLE, label: "People", className: hide || isWorkspaceAdmin ? "d-none" : "" },
    { key: PATHS.V2.WORKSPACE, label: "Workspace" },
    { key: PATHS.V2.SUBSCRIPTIONS, label: "Credits", className: hide || isWorkspaceAdmin ? "d-none" : "" },
    { key: PATHS.V2.BILLINGS, label: "Subscription & Billing", className: hide || isWorkspaceAdmin ? "d-none" : "" },
    { key: PATHS.V2.EDIT_PROFILE, label: "Profile" },
    // {
    //   danger: true,
    //   className: "mt-1",
    //   label: "Delete Account",
    //   key: "deleteAccount",
    // },
  ];

  const validItems = items?.filter((item) => item?.className !== "d-none");
  const isAllowedPath = validItems?.some((item) => item.key === pathname);

  // Redirect to the valid path
  if (!isAllowedPath) {
    if (isWorkspaceAdmin) return <Navigate to={PATHS.V2.WORKSPACE} />;
    if (isEditor || isCollaborator) return <Navigate to={PATHS.V2.EDIT_PROFILE} />;
    if (isAdmin || isOwner) return <Navigate to={PATHS.V2.ORGANIZATION} />;

    // Default redirect to the home page
    return <Navigate to={PATHS.V2.HOME} />;
  }

  // Navigate to the link
  const onClick = ({ key }) => {
    if (key !== "deleteAccount") navigate(key);
    else {
      modal.confirm({
        width: 500,
        centered: true,
        okText: "Yes, Delete My Account",
        className: "delete-warning-modal",
        onOk: () => console.log("Delete account"),
        title: "Are you sure you want to delete your account?",
        content:
          "This action is permanent and cannot be undone. If you proceed, we will be unable to restore this account in the future.",
        cancelButtonProps: { type: "default", size: "default" },
        okButtonProps: { danger: true, type: "primary", size: "default" },
        icon: (
          <Avatar
            size='large'
            className='bg-FEF0F4'
            icon={<CustomIcon name='user_x_01' height={24} width={24} className='color-F3164E' />}
          />
        ),
      });
    }
  };

  return <Menu mode='inline' items={items} onClick={onClick} className='settings-leftnav border-0' selectedKeys={[pathname]} />;
}
